module.exports = __webpack_public_path__ + "img/Home-Customised.2ed7f17d.jpg";